// extracted by mini-css-extract-plugin
export var parcelRow = "_rw-0";